import { gql } from "@apollo/client";

export const loadEngagementById = gql`
  query LoadEngagementById($id: ID!) {
    loadEngagementById(id: $id) {
      id
      profileId
      profileEmail
      profilePhone
      profileLogin
      campaignId
      engagementType
      deviceId
      campaignName
      performanceDate
      identifier
      productSkus
      programPoints
      campaignPoints
      status
      image
      channel
      vendorName
      outcomes {
        outcome
        value
      }
      metadata {
        packageData
        receiptData
        latitude
        longitude
        additionalInfo
      }
    }
  }
`;
